import "../css/style.css"

import { sliders } from "./modules/sliders"
import { schemePanZoom } from "./modules/scheme-pan-zoom"
import "./modules/iubenda"
import "./modules/leaflet-map"

window.MarvaGroup = {}

const afterLoad = () => {
    sliders.init()
    schemePanZoom.init()
}

// Ensure the DOM is fully loaded before initializing
document.addEventListener("DOMContentLoaded", afterLoad)